import { useCallback, useState } from 'react';

type UseBoolean = [boolean, () => void, (val: boolean) => void];

export const useBoolean = (initialValue = false): UseBoolean => {
  const [aBoolean, setBoolean] = useState(initialValue);

  const toggle = useCallback(
    () => setBoolean((prevState) => !prevState),
    [setBoolean],
  );

  return [aBoolean, toggle, setBoolean];
};
